import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";

import {
  EvidencionaListaMaloprodajnihObjekataPayload,
  EvidencionaListaMaloprodajnihObjekataProps,
  EvidencionaListaPosebanPostupakPayload,
  EvidencionaListaPosebanPostupakProps,
  GetRegistryParams,
  LastFourTablesProps,
  MfListaObjekataPsPayload,
  MfListaObjekataPsProps,
  MfTipObjektaOption,
  ObligeeRegistryConfigResponse,
  RegistarMaloprodajnihCenaPayload,
  RegistarMaloprodajnihCenaProps,
  RegistarOMarkamaDuvanskihProizvodaPayload,
  RegistarOMarkamaDuvanskihProizvodaProps,
  RegistryObligee,
  RegistryObligeeDetalji,
} from "./centralRegistry.types";

const getRegistryData = (
  payload: GetRegistryParams
): Promise<ApiResponseObject<RegistryObligee[]>> => {
  return axios.post("pregledRegistri", payload);
};

const getRegistryConfig = (): Promise<
  ApiResponseObject<ObligeeRegistryConfigResponse>
> => {
  return axios.get("pregledRegistriDodatneInformacije");
};

const getDetaljiObveznika = (
  id: number
): Promise<ApiResponseObject<RegistryObligeeDetalji>> => {
  return axios.get("detaljiPregledaRegistra", { params: { drustvoId: id } });
};

const postRegistarOMarkamaDuvanskihProizvoda = (
  payload: RegistarOMarkamaDuvanskihProizvodaPayload
): Promise<ApiResponseObject<RegistarOMarkamaDuvanskihProizvodaProps>> => {
  return axios.post("/registarOMarkamaDuvanskihProizvoda", payload);
};

const postRegistarMaloprodajnihCena = (
  payload: RegistarMaloprodajnihCenaPayload
): Promise<ApiResponseObject<RegistarMaloprodajnihCenaProps[]>> => {
  return axios.post("/registarMaloprodajnihCena", payload);
};

const postEvidencionaListaPosebanPostupak = (
  payload: EvidencionaListaPosebanPostupakPayload
): Promise<ApiResponseObject<EvidencionaListaPosebanPostupakProps[]>> => {
  return axios.post("/evidencionaListaPosebanPostupak", payload);
};

const postEvidencionaListaMaloprodajnihObjekata = (
  payload: EvidencionaListaMaloprodajnihObjekataPayload
): Promise<ApiResponseObject<EvidencionaListaMaloprodajnihObjekataProps[]>> => {
  return axios.post("/evidencionaListaMaloprodajnihObjekata", payload);
};

const postPrivredniSubjektiPosebanPostupak = (): Promise<
  ApiResponseObject<LastFourTablesProps[]>
> => {
  return axios.post("/privredniSubjektiPosebanPostupak");
};

const postRegistarTrgovacaNaVeliko = (): Promise<
  ApiResponseObject<LastFourTablesProps[]>
> => {
  return axios.post("/registarTrgovacaNaVeliko");
};

const getMfTipoviObjekata = (): Promise<
  ApiResponseObject<MfTipObjektaOption[]>
> => {
  return axios.get("/mfTipoviObjekata");
};

const postMfListaObjekataPs = (
  payload: MfListaObjekataPsPayload
): Promise<ApiResponseObject<MfListaObjekataPsProps[]>> => {
  return axios.post("/mfListaObjekataPs", payload);
};

export const centralRegistryRepo = {
  getRegistryData,
  getRegistryConfig,
  getDetaljiObveznika,
  postRegistarOMarkamaDuvanskihProizvoda,
  postRegistarMaloprodajnihCena,
  postEvidencionaListaPosebanPostupak,
  postEvidencionaListaMaloprodajnihObjekata,
  postPrivredniSubjektiPosebanPostupak,
  postRegistarTrgovacaNaVeliko,
  getMfTipoviObjekata,
  postMfListaObjekataPs,
};
